export const getApiHostname = () => {
    const hostname = window.location.hostname
    if (hostname.includes('alpsinsurance.com')) {
        return 'https://data.alpsinsurance.com'
    }
    return process.env.VUE_APP_API_BASE_URL || ''
}
